<script setup lang="ts">
import type { IDrawerInfoboxProps } from '../types'
import { EVariants } from '@/ui/plushComponents/VInfobox/types'

const props = defineProps<IDrawerInfoboxProps>()
</script>

<template>
    <section>
        <VDivider
            v-if="props.topDivider"
            class="mb-6 mt-2"
        />

        <VInfobox
            :variant="props.variant || EVariants.NEUTRAL"
            :title="props.title"
            :icon="!!props.icon"
            data-test="drawer-infobox"
        >
            <p v-html-gpp="props.paragraph" />
        </VInfobox>
    </section>
</template>
